import  * as React from "react";
import { observer } from "mobx-react";
import { IOptimizerTrajectoryTypeButtonsParams } from "./IOptimizerTrajectoryTypeButtonsParams";
import { IOptimizationType } from "Data";


@observer
export class OptimizerTrajectoryTypeButtons extends React.Component<IOptimizerTrajectoryTypeButtonsParams>{
    private driverOptimizedTypes: Array<IOptimizationType>;
    private ironOptimizedTypes: Array<IOptimizationType>;

    constructor(props: IOptimizerTrajectoryTypeButtonsParams) {
        super(props, undefined);
        console.log("props", props);
        const carry: IOptimizationType = {
            title: "Carry",
            value: "carry"
        };
        const total: IOptimizationType = {
            title: "Total",
            value: "total"
        };
        const combined: IOptimizationType = {
            title: "Carry & Total",
            value: "combined"
        };
        const high: IOptimizationType = {
            title: "High Trajectory",
            value: "high"
        };
        const medium: IOptimizationType = {
            title: "Mid Trajectory",
            value: "medium"
        };
        const low: IOptimizationType = {
            title: "Low Trajectory",
            value: "low"
        };
        this.driverOptimizedTypes = [
            carry,
            total,
            combined
        ];
        this.ironOptimizedTypes = [
            high,
            medium,
            low
        ];
    }

    changeOptimizationType(optimizationType: IOptimizationType): void {
        this.props.changeOptimizationType(optimizationType);
    }

    render() {
        let defaultOptimizedTypes = this.props.clubType !== "Driver" ? this.ironOptimizedTypes : this.driverOptimizedTypes;
        return <div className="OptimizerTrajectoryTypeButtons col-xs-8 optimizer-trajectory-details">
            <div className="trajectory-type-text">Trajectory Type</div>
            <div className="optimizer-trajectory-buttons">
                {this.props.optimizedTypes != null && this.props.optimizedTypes.map((type, i) => {
                    return <div className={type.value === this.props.selectedOptimizedType.value ? 'selected-optimizer-type' : ''} key={'a' + type.value} onClick={() => { this.changeOptimizationType(type) }}>
                        <span>{type.title}</span>
                    </div>
                })}
                {this.props.optimizedTypes == null && defaultOptimizedTypes.map((type, i) => {
                    return <div className={type.value === this.props.selectedOptimizedType.value ? 'selected-optimizer-type' : ''} key={'b' + type.value} onClick={() => { this.changeOptimizationType(type) }}>
                        <span>{type.title}</span>
                    </div>
                })}
            </div>
        </div >;
    }
}
